import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { REMOVE_ORGANISATION_RESOURCE, ORGANISATIONS_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import { ORGANISATION_STATES } from '../../helpers/activeStates';

const RemoveOrganisationService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_ORGANISATION_RESOURCE,
      method: 'delete',
      request: (id, callback, t) => ({
        url: apiRoutes.deleteOrganisation(id),
        meta: {
          callback,
          updateOtherList: {
            resource: ORGANISATIONS_RESOURCE,
            idProp: 'id',
            id,
            values: { activeState: ORGANISATION_STATES.DELETED },
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeOrganisationFailed'),
            onSuccessMessage: t('removeOrganisationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveOrganisationService;
